/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MitarbeiterDto } from '../../models/mitarbeiter-dto';
import { UpdateMitarbeiterDto } from '../../models/update-mitarbeiter-dto';

export interface UpdateMitarbeiter$Json$Params {

/**
 * ID des Mitarbeiters der aktualisiert werden soll
 */
  mitarbeiterId: string;
  
    /**
     * Aktualisierte Werte für den Mitarbeiter
     */
    body?: UpdateMitarbeiterDto
}

export function updateMitarbeiter$Json(http: HttpClient, rootUrl: string, params: UpdateMitarbeiter$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MitarbeiterDto>> {
  const rb = new RequestBuilder(rootUrl, updateMitarbeiter$Json.PATH, 'put');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MitarbeiterDto>;
    })
  );
}

updateMitarbeiter$Json.PATH = '/v1/mitarbeiter/{mitarbeiterId}';
